import {ObjectMapper} from "json-object-mapper";

import {FilterConfiguration} from "@app/shared/filters/filter-config.model";

export default class Filter {
  public readonly componentId: string;
  public config?: FilterConfiguration;

  constructor(componentId: string) {
    this.componentId  = componentId;
    this.config       = ObjectMapper.deserialize(FilterConfiguration, {});
  }

  public configure(config: FilterConfiguration): Filter {
    this.config = ObjectMapper.deserialize(FilterConfiguration, config);
    this.config.allowAll?.init();
    return this;
  }
}
